import { Component } from '@angular/core';
import { switchMap, take, takeUntil } from 'rxjs/operators';
import { PrizeBoxService } from 'src/app/services/client-area/prize-box.service';
import { AvatarService } from 'src/app/services/profile/avatar.service';
import { BasePageComponent } from '../../base-page/base-page.component';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { LicenceService } from 'src/app/services/utils/licence.service';

@Component({
  selector: 'app-profile-button',
  templateUrl: './profile-button.component.html',
  styleUrls: ['./profile-button.component.scss']
})
export class ProfileButtonComponent extends BasePageComponent {

  constructor(
    public avatarService: AvatarService,
    public prizeBoxService: PrizeBoxService,
    public licenceService: LicenceService,
    private loginStatusService: LoginStatusService,
  ) { super() }

  avatar: string;
  hasPrizes: boolean = false;
  userRole: boolean;


  ngOnInit(): void {
    this.avatarService.getAvatar().pipe(takeUntil(this.unsubscribe)).subscribe(data => this.avatar = data);
    this.loginStatusService.getLoginStatus().pipe(takeUntil(this.unsubscribe)).subscribe(resp => {
      let roleList = (resp.fullInfo?.roles as string[]) || [];
      if(roleList)
        roleList = roleList.map(role => role.toLowerCase());
      this.userRole = roleList.some(role=>this.loginStatusService.vipRoles.includes(role));
    })
    this.prizeBoxService.getCurrentLevelLottery().pipe(
      switchMap(() => this.prizeBoxService.isActiveLottery()),
      takeUntil(this.unsubscribe)).subscribe(resp => {
        this.hasPrizes = resp;
      })
  }

}
